import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";
import AuthValidation from "../../validation/AuthValidation";

export class ForgottenPasswordCompleteRequest implements IRequestModel {

    constructor(passResetKey: string, newPassword: string) {
        this.password_reset_key = passResetKey;
        this.new_password = newPassword;
    }

    uri: string = "auth/forgot-pass";
    method: HttpMethod = HttpMethod.PATCH;

    password_reset_key: string;
    new_password: string;

    isValid(): ValidationResponse {
        let passResp: ValidationResponse = AuthValidation.PasswordValid(this.new_password, "New Password");
        if (!passResp.isSuccess) {
            return passResp;
        }

        let keyResp: ValidationResponse = AuthValidation.VerifKeyValid(this.password_reset_key, "Password Reset Key");
        return keyResp;
    }
}